export const MAX_BANK_SLIP = 3
